@for (star of [].constructor(5); track $index; let i = $index) {
    <bazis-star
        part="star"
        [isActive]="hasActive(i + 1)"
        [isHalf]="hasHalf(i + 1)"
    ></bazis-star>
}
